import { Box, Skeleton } from "@repo/ui";

export const CourseCardLoader = () => {
  return (
    <Box className="border rounded-xl bg-white p-4 w-full">
      <Skeleton width={100} size={142} className="!rounded-xl">
        <svg
          className="size-12"
          aria-hidden="true"
          xmlns="http://www.w3.org/2000/svg"
          fill="currentColor"
          viewBox="0 0 20 18"
        >
          <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
        </svg>
      </Skeleton>
      <Box className="mt-4 flex justify-between">
        <Box className="flex-1">
          <Skeleton className="mb-2" width={40} size={14} />
          <Skeleton className="mb-2" width={80} size={14} />
        </Box>
        <Skeleton variant="circle" width={40} size={40} />
      </Box>
      <Skeleton className="mt-2" width={90} size={33} />
      <Box className="flex mt-5">
        <Box className="w-6/12">
          <Skeleton width={50} size={14} />
          <Skeleton className="mt-4 mb-5" width={50} size={14} />
        </Box>
        <Box className="w-6/12 justify-self-end">
          <Skeleton width={70} size={14} />
          <Skeleton className="mt-4 " width={100} size={20} />
        </Box>
      </Box>

      <Skeleton className="" width={100} size={1} />

      <Box className="mt-4 flex gap-4">
        <Skeleton width={55} size={36} />
        <Skeleton width={45} size={36} />
      </Box>
    </Box>
  );
};
